import utility from 'src/utils/utility'
import { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import ApiContext from 'src/provider/API/call-service'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import { 
    AppSpan, Button, CustomContainer, FlexRow, Form, 
    FormGroup, GridContainer, ScreenContainer, ScreenTitle 
} from 'src/style'


const Identification: React.FC = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {info, setInfoProperty} = useContext(AppInfoContext)
    const [email, setEmail] = useState('')

    async function handleNext(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()

        const response = await API.sendOtpForPasswordReset(email)

        if (response) {
            await setInfoProperty('userData', {...info.userData, email})
            navigate('/forgot-password/password-reset')
        }
    }
    
    return (
        <ScreenContainer padding='2.5' >
            <GridContainer 
                height='100' hUnit='%'
            >
                <CustomContainer className='preauth-screen-wrapper'>
                    <CustomContainer>
                        <ScreenTitle 
                            color='#000000'
                            textSize='3.2'
                            fontWeight='700'
                        >
                            Forgot Password
                        </ScreenTitle>
                        <AppSpan
                            textSize='1.6'
                            color='#4F4F4F'
                        >
                            Lorem ac, arcu, at sed vestibulum, malesuada. Amet, orci ultrices pellentesque aliquam nec. 
                        </AppSpan>
                    </CustomContainer>
                    <Form topMargin='4' onSubmit={handleNext}>
                        <FormGroup>
                            <label>Email</label>
                            <input 
                                placeholder='Enter Email' 
                                name='email'
                                type='email'
                                value={email}
                                autoComplete="off"
                                required
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </FormGroup>
                        
                        <FlexRow 
                            justifyContent='flex-end' topMargin='2'
                            gap='1.5'
                        >
                            <Button 
                                width='50' 
                                sizeUnit='%'
                                bgColor='#ffffff' 
                                color='#5627FF'
                                hoverColor='#5627FF'
                                borderColor='#5627FF'
                                type="button"
                                onClick={() => navigate(-1)}
                            >
                                Back
                            </Button>
                            <Button 
                                width='50' 
                                sizeUnit='%'
                                hoverBgColor='#ffffff' 
                                hoverColor='#5627FF'
                                borderColor='#5627FF'
                            >
                                Reset Password
                            </Button>
                        </FlexRow>
                    </Form>
                </CustomContainer>
            </GridContainer>
        </ScreenContainer>
    )
}

export default utility.routeData('/forgot-password/identification', 'Forgot Password Identification', <Identification/>)